import * as types from './account-project.types';
import * as constants from './account-project.constants';
import { generateResourceReducer } from '../generators/resource.reducer';

export const accountProjectReducer = generateResourceReducer<types.IAccountProject>({
  STORE: constants.STORE_ACCOUNT_PROJECT,
  CLEAR: constants.CLEAR_ACCOUNT_PROJECT,
});
